import React, { useEffect } from "react";
import Select from "react-select";
import { FieldFeedback, FormValidationNotice, RequiredMark } from "../../../../components/FormValidation";
import useFormValidation from "../../../../hooks/useFormValidation";
import { validationRules as rule } from "../../../../utils/helpers/formValidation";

const villageSchema = {
  district_id: rule.required("Kecamatan wajib dipilih."),
  id: rule.required("Kode kelurahan wajib diisi."),
  name: rule.required("Nama kelurahan wajib diisi."),
};

const FormVillage = (props) => {
  const { isEdit, closeModal, formState, setFormState, fetchDistricts, districts, handleAdd, handleUpdate } = props;
  const validation = useFormValidation({ values: formState, schema: villageSchema, formId: "village" });
  const submit = async (event) => {
    event.preventDefault();
    if (!validation.validateAll()) return;
    const success = isEdit ? await handleUpdate() : await handleAdd();
    if (success !== false) document.querySelector("#modal-form .btn-close")?.click();
  };

  const options = districts?.map((item) => {
    return {
      value: item?.id,
      label: item?.name,
    };
  });

  useEffect(() => {
    fetchDistricts(10000, 1, "");
  }, [fetchDistricts]);

  return (
    <div
      className="modal modal-blur fade "
      id="modal-form"
      tabIndex="-1"
      role="dialog"
      aria-hidden="false"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.3)",
      }}>
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <form className="modal-content" onSubmit={submit} noValidate>
          <div className="modal-header">
            <h5 className="modal-title">Master Kelurahan {!isEdit ? "Baru" : "Edit"}</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}></button>
          </div>
          <div className="modal-body">
            <FormValidationNotice errors={validation.errors} />
            <div className="row">
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="form-label">Kecamatan<RequiredMark /></label>
                  <Select
                    {...validation.fieldProps("district_id")}
                    data-validation-field="district_id"
                    options={!options ? [] : options}
                    name="district_id"
                    className={validation.inputClass("district_id", "form-select p-0")}
                    classNamePrefix="akas-select"
                    styles={{
                      control: (base) => ({
                        ...base,
                        border: "none",
                        borderRadius: "8px",
                        boxShadow: "none",
                        "&:hover": {
                          border: "none",
                          boxShadow: "none",
                        },
                        option: (base, state) => ({
                          ...base,
                          backgroundColor: state.isSelected
                            ? "#32CD32" // item yang dipilih
                            : state.isFocused
                              ? "#90EE90" // saat hover
                              : "#FFF", // default
                          color: state.isSelected
                            ? "#FFF" // item yang dipilih
                            : state.isFocused
                              ? "#000" // saat hover
                              : "#000", // default
                          cursor: "pointer",
                        }),
                      }),
                    }}
                    value={options?.find((item) => item?.value === formState?.district_id) || null}
                    onChange={(event) => {
                      setFormState({
                        ...formState,
                        district_id: event?.value,
                      });
                    }}
                    placeholder="-- Pilih Kecamatan --"
                  />
                  <FieldFeedback formId="village" name="district_id" error={validation.errors.district_id} hint="Pilih kecamatan induk kelurahan/desa." />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="form-label">Kode<RequiredMark /></label>
                  <input
                    {...validation.fieldProps("id")}
                    type="text"
                    className={validation.inputClass("id")}
                    placeholder="kode kelurahan"
                    value={formState?.id || ""}
                    onChange={(e) =>
                      setFormState((prev) => ({
                        ...prev,
                        id: e.target.value,
                      }))
                    }
                  />
                  <FieldFeedback formId="village" name="id" error={validation.errors.id} hint="Gunakan kode wilayah resmi dan unik." />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="form-label">Nama<RequiredMark /></label>
                  <input
                    {...validation.fieldProps("name")}
                    type="text"
                    className={validation.inputClass("name")}
                    placeholder="nama kelurahan"
                    value={formState?.name || ""}
                    onChange={(e) =>
                      setFormState((prev) => ({
                        ...prev,
                        name: e.target.value,
                      }))
                    }
                  />
                  <FieldFeedback formId="village" name="name" error={validation.errors.name} hint="Nama kelurahan/desa wajib diisi." />
                </div>
              </div>

              <div className="col-lg-12">
                <div>
                  <label className="form-label">Informasi Tambahan</label>
                  <textarea className="form-control" rows="3"></textarea>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-link link-secondary btn-3" data-bs-dismiss="modal">
              {" "}
              Cancel{" "}
            </button>
            {isEdit ? (
              <button
                type="submit"
                className="btn btn-primary btn-5 ms-auto"
                >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-edit">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                  <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
                  <path d="M16 5l3 3" />
                </svg>
                Edit Data
              </button>
            ) : (
              <button
                type="submit"
                className="btn btn-primary btn-5 ms-auto"
                >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-2">
                  <path d="M12 5l0 14" />
                  <path d="M5 12l14 0" />
                </svg>
                Tambah Data
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormVillage;
